const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const { Base64 } = require('js-base64');
const apiConfig = require('../../api-config');

function apiFactory({
  baseUrl,
  requestHandler,
}) {
  const headers = {
    'Content-Type': 'application/json',
  };
  const reqOpts = { headers, method: 'POST' };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {

    validateMultisignPayment( inputParam, metaData) {
      const url = getUrl('approver/multisig-payment/validate');
      const reqOpts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const language = parsedMetaData.portfolio.language;
      const params = JSON.parse(Base64.decode(inputParam));

      const body = {
        approverId: parsedMetaData.qs.userId,
        paymentUUID: params.paymentUUID,
        deviceCode: params.deviceCode,
        branchCode: apiConfig.branchCode,
        language: language,
        channel: params.channel,
      }
      
      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },
    resumeMultisignPayment( inputParam, metaData) {
      const url = getUrl('approver/multisig-payment/resume');
      const reqOpts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const language = parsedMetaData.portfolio.language;
      const params = JSON.parse(Base64.decode(inputParam));

      const body = {
        approverId: parsedMetaData.qs.userId,
        paymentUUID: params.paymentUUID,
        deviceCode: params.deviceCode,
        branchCode: apiConfig.branchCode,
        language: language,
        channel: params.channel,
      }
      
      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },
 fetchMultiSignNotification( inputParam, metaData) {
      const url = getUrl('user/notifications/fetch');
      const reqOpts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const params = JSON.parse(Base64.decode(inputParam));
      const body = {
        userId : parsedMetaData.qs.userId, 
        isFreshLogin : params.isFreshLogin,
      }
      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },


  };
}

module.exports = apiFactory;